import React from 'react'
import '../styles/BottomNav.css'
import { FaCalendarCheck, FaMapMarkerAlt, FaGift } from 'react-icons/fa'
import { T } from './Translation'

const BottomNav = ({ setActiveTab, activeTab }) => {
  return (
    <div className="bottom-nav">
      <div
        className={`nav-item ${activeTab === 'rsvp' ? 'active' : ''}`}
        onClick={() => setActiveTab('rsvp')}
      >
        <FaCalendarCheck className="nav-icon" />
        <span>
          <T k="rsvp" />
        </span>
      </div>
      <div
        className={`nav-item ${activeTab === 'location' ? 'active' : ''}`}
        onClick={() => setActiveTab('location')}
      >
        <FaMapMarkerAlt className="nav-icon" />
        <span>
          <T k="location" />
        </span>
      </div>
      {/* <div
        className={`nav-item ${activeTab === 'present' ? 'active' : ''}`}
        onClick={() => setActiveTab('present')}
      >
        <FaGift className="nav-icon" />
        <span>
          <T k="present" />
        </span>
      </div> */}
    </div>
  )
}

export default BottomNav
